import { Form, Input} from 'antd'
import React from "react"

export default Form.create({
  onFieldsChange (props, changedFields) {
    if (typeof props.onChange === 'function') {
      props.onChange(changedFields.value.value)
    }
  },
  mapPropsToFields (props) {
    return {
      value: Form.createFormField({
        value: props.value
      })
    }
  }
})((props) => {
  const { getFieldDecorator } = props.form
  return (
    <Form>
      <Form.Item>
        {getFieldDecorator('value')(<Input/>)}
      </Form.Item>
    </Form>
  )
})